module.exports = __webpack_public_path__ + "static/media/2_Noticeable.0206776a.svg";